import { Outlet } from 'react-router-dom';
import { Header } from '@/app/layouts/MainLayout/Header.tsx';

/**
 * 인증 페이지(로그인 / 회원가입 / 비밀번호 재설정 / 메일 링크) 레이아웃.
 * Header·Footer 없이 중앙 정렬 카드 한 장만 보여주는 미니멀 화면.
 *
 * 만약 로고+우상단 메뉴 같은 미니 헤더가 필요해지면:
 *   - 별도 컴포넌트(AuthHeader 등)로 추가하고 여기서 import
 *   - MainLayout/Header는 재사용하지 말 것 (성격이 다른 헤더)
 */
function AuthLayout() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-slate-50 dark:bg-dark-base">
      <Header />
      {/* 모바일에서 카드가 화면 끝에 붙지 않게 좌우 여백을 둔다. 데스크톱은 max-w 가운데 정렬이라 필요 없다. */}
      <div className="w-full max-w-md px-5 sm:px-0">
        <Outlet />
      </div>
    </div>
  );
}

export default AuthLayout;
